// extracted by mini-css-extract-plugin
export default {"form":"styles_form__QYMHy","labelContainer":"styles_labelContainer__9bkQz"};